<template>
    <div class="power">
        <div v-show="routerLevel === 2">
            <!--<div class="common-search-container common-shadow">
                <div class="common-header">
                    搜索筛选
                </div>
                <div class="content">
                    <el-form
                        :inline="true"
                        :model="searchParams">
                        <el-form-item label="显示名称">
                            <el-input
                                v-model="searchParams.name"
                                clearable />
                        </el-form-item>
                        <el-button
                            type="primary"
                            round
                            @click="getData">
                            查询
                        </el-button>
                    </el-form>
                </div>
            </div>-->
            <div>
                <div class="common-table-title">
                    <span class="tit">
                        数据列表
                    </span>
                    <el-button
                        type="primary"
                        round
                        @click="operationPower({ row: { parent_id: 0, level: 0 } }, true)">
                        添加
                    </el-button>
                </div>
                <el-table
                    class="table common-shadow"
                    stripe
                    :data="tableData"
                    v-loading="loading">
                    <el-table-column
                        prop="display_name"
                        label="显示名称"
                        min-width="110" />
                    <el-table-column
                        prop="name"
                        label="路由"
                        min-width="110" />
                    <el-table-column
                        prop="icon"
                        label="图标"
                        min-width="80" />
                    <el-table-column
                        prop="is_menu"
                        label="是否菜单"
                        min-width="100">
                        <template slot-scope="scope">
                            {{ scope.row.is_menu ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作"
                        min-width="200">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="operationPower(scope)">
                                编辑
                            </el-button>
                            <el-button
                                type="text"
                                @click="del(scope.row.id)">
                                删除
                            </el-button>
                            <el-button
                                type="text"
                                @click="goDetails(scope.row.id)">
                                管理子菜单
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <router-view />
        <operation-power
            ref="power"
            @done="onOperationPowerDone" />
    </div>
</template>

<script>
import { getPowerList, deletePower } from '../../../api';
import { openComfirm } from '../../../utils/common';
import OperationPower from './components/Power';

export default {
    name: 'PowerList',
    props: {
        routerLevel: {
            type: Number,
            default: 2,
            required: true
        }
    },
    data () {
        return {
            loading: true,
            tableData: [],
            visible: false
        };
    },
    created () {
        this.getData();
    },
    beforeRouteUpdate (to, from, next) {
        if (to.name === 'permissions.index') {
            this.getData();
        }
        next();
    },
    methods: {
        async getData () {
            try {
                this.loading = true;
                const res = await getPowerList();
                this.loading = false;
                if (res) {
                    const { type, category } = res;
                    this.tableData = res;
                    if (type) this.auctionStatus = type;
                    if (category) this.category = category;
                }
            } catch (err) {
                console.error(err);
                this.loading = false;
            }

        },
        goDetails (id) {
            this.$router.push({
                name: 'permissions.show',
                params: {
                    id
                }
            });
        },
        goEdit (id) { // 进入编辑、添加权限
            let name = 'permissions.index.create';
            if (id) name = 'permissions.edit';
            this.$router.push({
                name,
                params: {
                    id,
                    lastId: 0
                }
            });
        },
        async del (id) {
            try {
                const apiFn = (id) => {
                    return () => {
                        return deletePower(id);
                    };
                };
                await openComfirm({
                    title: '提示',
                    message: '您确定要删除吗？',
                    successTip: '删除成功!',
                    apiFn: apiFn(id)
                });
                const index = this.tableData.findIndex(c => c.id === id);
                if (index !== -1) this.tableData.splice(index, 1);
            } catch (err) {
                console.error(err);
            }
        },
        handleCurrentChange (val) {
            this.getData(val);
        },
        operationPower (data, isCreate) {
            this.$refs.power.open(data, isCreate);
        },
        onOperationPowerCreate (data) {
            if (data) this.tableData.push(data);
        },
        onOperationPowerDone (data) {
            if (data) {
                const { _key, id } = data;
                const { tableData } = this;
                const index = tableData.findIndex(c => c.id === id);
                switch (_key) {
                    case 'create':
                        if (data.parent_id === 0) this.tableData.push(data);
                        break;
                    case 'update':
                        if (index !== -1) tableData.splice(index, 1, data);
                        break;
                    case 'delete':
                        if (index !== -1) tableData.splice(index, 1);
                        break;
                }

            }
        }
    },
    components: {
        OperationPower
    }
};
</script>

<style lang="scss" scoped>
    .power {

    }
</style>
